import {defineSemanticTokens} from '@chakra-ui/react3'

const chakraSemanticColors = defineSemanticTokens.colors({
    bg: {
        DEFAULT: {
            value: {_light: '{colors.white}', _dark: '{colors.black}'}
        },
        subtle: {
            value: {_light: '{colors.gray.50}', _dark: '{colors.gray.950}'}
        },
        muted: {
            value: {_light: '{colors.gray.100}', _dark: '{colors.gray.900}'}
        },
        emphasized: {
            value: {_light: '{colors.gray.200}', _dark: '{colors.gray.800}'}
        },
        inverted: {
            value: {_light: '{colors.black}', _dark: '{colors.white}'}
        },
        panel: {
            value: {_light: '{colors.white}', _dark: '{colors.gray.950}'}
        },
        error: {
            value: {_light: '{colors.red.50}', _dark: '{colors.red.950}'}
        },
        warning: {
            value: {_light: '{colors.orange.50}', _dark: '{colors.orange.950}'}
        },
        success: {
            value: {_light: '{colors.green.50}', _dark: '{colors.green.950}'}
        },
        info: {
            value: {_light: '{colors.blue.50}', _dark: '{colors.blue.950}'}
        }
    },
    fg: {
        DEFAULT: {
            value: {_light: '{colors.black}', _dark: '{colors.gray.50}'}
        },
        muted: {
            value: {_light: '{colors.gray.600}', _dark: '{colors.gray.400}'}
        },
        subtle: {
            value: {_light: '{colors.gray.400}', _dark: '{colors.gray.500}'}
        },
        inverted: {
            value: {_light: '{colors.gray.50}', _dark: '{colors.black}'}
        },
        error: {
            value: {_light: '{colors.red.500}', _dark: '{colors.red.400}'}
        },
        warning: {
            value: {_light: '{colors.orange.600}', _dark: '{colors.orange.300}'}
        },
        success: {
            value: {_light: '{colors.green.600}', _dark: '{colors.green.300}'}
        },
        info: {
            value: {_light: '{colors.blue.600}', _dark: '{colors.blue.300}'}
        }
    },
    border: {
        DEFAULT: {
            value: {_light: '{colors.gray.200}', _dark: '{colors.gray.800}'}
        },
        muted: {
            value: {_light: '{colors.gray.100}', _dark: '{colors.gray.900}'}
        },
        subtle: {
            value: {_light: '{colors.gray.50}', _dark: '{colors.gray.950}'}
        },
        emphasized: {
            value: {_light: '{colors.gray.300}', _dark: '{colors.gray.700}'}
        },
        inverted: {
            value: {_light: '{colors.gray.800}', _dark: '{colors.gray.200}'}
        },
        error: {
            value: {_light: '{colors.red.500}', _dark: '{colors.red.400}'}
        },
        warning: {
            value: {_light: '{colors.orange.500}', _dark: '{colors.orange.400}'}
        },
        success: {
            value: {_light: '{colors.green.500}', _dark: '{colors.green.400}'}
        },
        info: {
            value: {_light: '{colors.blue.500}', _dark: '{colors.blue.400}'}
        }
    },

    gray: {
        contrast: {
            value: {_light: '{colors.white}', _dark: '{colors.black}'}
        },
        fg: {
            value: {_light: '{colors.gray.800}', _dark: '{colors.gray.200}'}
        },
        subtle: {
            value: {_light: '{colors.gray.100}', _dark: '{colors.gray.900}'}
        },
        muted: {
            value: {_light: '{colors.gray.200}', _dark: '{colors.gray.800}'}
        },
        emphasized: {
            value: {_light: '{colors.gray.300}', _dark: '{colors.gray.700}'}
        },
        solid: {
            value: {_light: '{colors.gray.900}', _dark: '{colors.white}'}
        },
        focusRing: {
            value: {_light: '{colors.gray.400}', _dark: '{colors.gray.400}'}
        }
    },

    red: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.red.700}', _dark: '{colors.red.300}'}
        },
        subtle: {
            value: {_light: '{colors.red.100}', _dark: '{colors.red.900}'}
        },
        muted: {
            value: {_light: '{colors.red.200}', _dark: '{colors.red.800}'}
        },
        emphasized: {
            value: {_light: '{colors.red.300}', _dark: '{colors.red.700}'}
        },
        solid: {
            value: {_light: '{colors.red.600}', _dark: '{colors.red.600}'}
        },
        focusRing: {
            value: {_light: '{colors.red.500}', _dark: '{colors.red.500}'}
        }
    },

    orange: {
        contrast: {
            value: {_light: 'white', _dark: 'black'}
        },
        fg: {
            value: {_light: '{colors.orange.700}', _dark: '{colors.orange.300}'}
        },
        subtle: {
            value: {_light: '{colors.orange.100}', _dark: '{colors.orange.900}'}
        },
        muted: {
            value: {_light: '{colors.orange.200}', _dark: '{colors.orange.800}'}
        },
        emphasized: {
            value: {_light: '{colors.orange.300}', _dark: '{colors.orange.700}'}
        },
        solid: {
            value: {_light: '{colors.orange.600}', _dark: '{colors.orange.500}'}
        },
        focusRing: {
            value: {_light: '{colors.orange.500}', _dark: '{colors.orange.500}'}
        }
    },

    green: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.green.700}', _dark: '{colors.green.300}'}
        },
        subtle: {
            value: {_light: '{colors.green.100}', _dark: '{colors.green.900}'}
        },
        muted: {
            value: {_light: '{colors.green.200}', _dark: '{colors.green.800}'}
        },
        emphasized: {
            value: {_light: '{colors.green.300}', _dark: '{colors.green.700}'}
        },
        solid: {
            value: {_light: '{colors.green.600}', _dark: '{colors.green.600}'}
        },
        focusRing: {
            value: {_light: '{colors.green.500}', _dark: '{colors.green.500}'}
        }
    },

    blue: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.blue.700}', _dark: '{colors.blue.300}'}
        },
        subtle: {
            value: {_light: '{colors.blue.100}', _dark: '{colors.blue.900}'}
        },
        muted: {
            value: {_light: '{colors.blue.200}', _dark: '{colors.blue.800}'}
        },
        emphasized: {
            value: {_light: '{colors.blue.300}', _dark: '{colors.blue.700}'}
        },
        solid: {
            value: {_light: '{colors.blue.600}', _dark: '{colors.blue.600}'}
        },
        focusRing: {
            value: {_light: '{colors.blue.500}', _dark: '{colors.blue.500}'}
        }
    },

    yellow: {
        contrast: {
            value: {_light: 'black', _dark: 'black'}
        },
        fg: {
            value: {_light: '{colors.yellow.800}', _dark: '{colors.yellow.300}'}
        },
        subtle: {
            value: {_light: '{colors.yellow.100}', _dark: '{colors.yellow.900}'}
        },
        muted: {
            value: {_light: '{colors.yellow.200}', _dark: '{colors.yellow.800}'}
        },
        emphasized: {
            value: {_light: '{colors.yellow.300}', _dark: '{colors.yellow.700}'}
        },
        solid: {
            value: {_light: '{colors.yellow.300}', _dark: '{colors.yellow.300}'}
        },
        focusRing: {
            value: {_light: '{colors.yellow.500}', _dark: '{colors.yellow.500}'}
        }
    },

    teal: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.teal.700}', _dark: '{colors.teal.300}'}
        },
        subtle: {
            value: {_light: '{colors.teal.100}', _dark: '{colors.teal.900}'}
        },
        muted: {
            value: {_light: '{colors.teal.200}', _dark: '{colors.teal.800}'}
        },
        emphasized: {
            value: {_light: '{colors.teal.300}', _dark: '{colors.teal.700}'}
        },
        solid: {
            value: {_light: '{colors.teal.600}', _dark: '{colors.teal.600}'}
        },
        focusRing: {
            value: {_light: '{colors.teal.500}', _dark: '{colors.teal.500}'}
        }
    },

    purple: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.purple.700}', _dark: '{colors.purple.300}'}
        },
        subtle: {
            value: {_light: '{colors.purple.100}', _dark: '{colors.purple.900}'}
        },
        muted: {
            value: {_light: '{colors.purple.200}', _dark: '{colors.purple.800}'}
        },
        emphasized: {
            value: {_light: '{colors.purple.300}', _dark: '{colors.purple.700}'}
        },
        solid: {
            value: {_light: '{colors.purple.600}', _dark: '{colors.purple.600}'}
        },
        focusRing: {
            value: {_light: '{colors.purple.500}', _dark: '{colors.purple.500}'}
        }
    },

    pink: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.pink.700}', _dark: '{colors.pink.300}'}
        },
        subtle: {
            value: {_light: '{colors.pink.100}', _dark: '{colors.pink.900}'}
        },
        muted: {
            value: {_light: '{colors.pink.200}', _dark: '{colors.pink.800}'}
        },
        emphasized: {
            value: {_light: '{colors.pink.300}', _dark: '{colors.pink.700}'}
        },
        solid: {
            value: {_light: '{colors.pink.600}', _dark: '{colors.pink.600}'}
        },
        focusRing: {
            value: {_light: '{colors.pink.500}', _dark: '{colors.pink.500}'}
        }
    },

    cyan: {
        contrast: {
            value: {_light: 'white', _dark: 'white'}
        },
        fg: {
            value: {_light: '{colors.cyan.700}', _dark: '{colors.cyan.300}'}
        },
        subtle: {
            value: {_light: '{colors.cyan.100}', _dark: '{colors.cyan.900}'}
        },
        muted: {
            value: {_light: '{colors.cyan.200}', _dark: '{colors.cyan.800}'}
        },
        emphasized: {
            value: {_light: '{colors.cyan.300}', _dark: '{colors.cyan.700}'}
        },
        solid: {
            value: {_light: '{colors.cyan.600}', _dark: '{colors.cyan.600}'}
        },
        focusRing: {
            value: {_light: '{colors.cyan.500}', _dark: '{colors.cyan.500}'}
        }
    }
})

const leapSemanticColors = defineSemanticTokens.colors({
    background: {
        section: {
            default: {value: {base: 'rgba(243, 240, 235, 1)', _dark: 'rgba(20, 20, 20, 1)'}},
            subtle: {value: {base: 'rgba(249, 248, 245, 1)', _dark: 'rgba(26, 26, 26, 1)'}},
            strong: {value: {base: 'rgba(238, 233, 226, 1)', _dark: 'rgba(15, 15, 15, 1)'}}
        },
        brand: {
            light: {value: {base: 'rgba(255, 241, 228, 1)', _dark: 'rgba(255, 241, 228, 1)'}}
        },
        surface: {
            'on-section-default': {
                value: {base: 'rgba(238, 233, 226, 1)', _dark: 'rgba(15, 15, 15, 1)'}
            },
            'on-section-subtle': {
                value: {base: 'rgba(243, 240, 235, 1)', _dark: 'rgba(20, 20, 20, 1)'}
            },
            'on-section-strong': {
                value: {base: 'rgba(249, 248, 245, 1)', _dark: 'rgba(26, 26, 26, 1)'}
            },
            'on-section-inverted': {
                value: {base: 'rgba(255,255,255, 1)', _dark: 'rgba(0, 0, 0, 1)'}
            }
        },

        overlay: {
            light: {value: {base: 'rgba(0, 0, 0, 0.1)', _dark: 'rgba(0, 0, 0, 0.1)'}},
            'light-inverted': {
                value: {base: 'rgba(0, 0, 0, 0.08)', _dark: 'rgba(255, 255, 255, 0.08)'}
            },
            subtle: {value: {base: 'rgba(0, 0, 0, 0.3)', _dark: 'rgba(0, 0, 0, 0.3)'}},
            medium: {value: {base: 'rgba(0, 0, 0, 0.4)', _dark: 'rgba(0, 0, 0, 0.4)'}},
            strong: {value: {base: 'rgba(0, 0, 0, 0.8)', _dark: 'rgba(0, 0, 0, 0.8)'}}
        },

        system: {
            'success-light': {
                value: {base: 'rgba(231, 234, 217, 1)', _dark: 'rgba(231, 234, 217, 1)'}
            },
            'success-subtle': {
                value: {base: 'rgba(207, 217, 189, 1)', _dark: 'rgba(207, 217, 189, 1)'}
            },
            'success-strong': {
                value: {base: 'rgba(78, 130, 74, 1)', _dark: 'rgba(80, 147, 89, 1)'}
            },
            'success-strong-hover': {
                value: {base: 'rgba(80, 114, 68, 1)', _dark: 'rgba(78, 130, 74, 1)'}
            },

            'warning-light': {
                value: {base: 'rgba(254, 228, 202, 1)', _dark: 'rgba(254, 228, 202, 1)'}
            },
            'warning-subtle': {
                value: {base: 'rgba(253, 201, 149, 1)', _dark: 'rgba(253, 201, 149, 1)'}
            },
            'warning-strong': {
                value: {base: 'rgba(211, 105, 2, 1)', _dark: 'rgba(254, 228, 202, 1)'}
            },
            'warning-strong-hover': {
                value: {base: 'rgba(182, 92, 2, 1)', _dark: 'rgba(211, 105, 2, 1)'}
            },

            'error-light': {
                value: {base: 'rgba(246, 232, 233, 1)', _dark: 'rgba(246, 232, 233, 1)'}
            },
            'error-subtle': {
                value: {base: 'rgba(241, 217, 218, 1)', _dark: 'rgba(241, 217, 218, 1)'}
            },
            'error-strong': {value: {base: 'rgba(184, 67, 68, 1)', _dark: 'rgba(209, 70, 71, 1)'}},
            'error-strong-hover': {
                value: {base: 'rgba(160, 64, 64, 1)', _dark: 'rgba(184, 67, 68, 1)'}
            }
        },

        actions: {
            primary: {value: {base: 'rgba(182, 92, 2, 1)', _dark: 'rgba(182, 92, 2, 1)'}},
            'primary-hover': {value: {base: 'rgba(161, 82, 2, 1)', _dark: 'rgba(161, 82, 2, 1)'}},

            secondary: {value: {base: 'rgba(26, 26, 26, 1)', _dark: 'rgba(255, 255, 255, 1)'}},
            'secondary-hover': {
                value: {base: 'rgba(43, 43, 43, 1)', _dark: 'rgba(252, 252, 252, 1)'}
            },

            neutral: {value: {base: 'rgba(30, 30, 30, 1)', _dark: 'rgba(255,255,255, 1)'}},
            'neutral-hover': {
                value: {base: 'rgba(36, 36, 36, 1)', _dark: 'rgba(252, 252, 252, 1)'}
            },

            tertiary: {value: {base: 'rgba(255, 255, 255, 1)', _dark: 'rgba(26, 26, 26, 1)'}},
            'tertiary-hover': {
                value: {base: 'rgba(247, 247, 247, 1)', _dark: 'rgba(20, 20, 20, 1)'}
            },
            'tertiary-active': {
                value: {base: 'rgba(245, 245, 245, 1)', _dark: 'rgba(25, 25, 25, 1)'}
            },

            'carousel-bar': {
                value: {base: 'rgba(0, 0, 0, 0.24)', _dark: 'rgba(255, 255, 255, 0.40)'}
            },

            ghost: {value: {base: 'rgba(0, 0, 0, 0.1)', _dark: 'rgba(255, 255, 255, 0.2)'}},
            'ghost-hover': {value: {base: 'rgba(0, 0, 0, 0.2)', _dark: 'rgba(255, 255, 255, 0.3)'}},

            'on-surface-media': {value: 'rgba(255, 255, 255, 0.16)'},
            'on-surface-media-hover': {value: 'rgba(255, 255, 255, 0.24)'},

            'on-media': {
                white: {value: 'rgba(255, 255, 255, 1)'},
                active: {value: 'rgba(211, 105, 2, 1)'},
                ghost: {value: 'rgba(255, 255, 255, 0.2)'},
                'ghost-hover': {value: 'rgba(255, 255, 255, 0.3)'},
                'carousel-ticker': {value: 'rgba(255, 255, 255, 0.5)'}
            }
        }
    },

    text: {
        primary: {value: {base: 'rgba(15, 15, 15, 1)', _dark: 'rgba(255,255,255, 1)'}},
        'primary-inverted': {value: {base: 'rgba(255,255,255, 1)', _dark: 'rgba(15, 15, 15, 1)'}},
        secondary: {value: {base: 'rgba(66, 66, 66, 1)', _dark: 'rgba(163, 163, 163, 1)'}},
        tertiary: {value: {base: 'rgba(115, 115, 115, 1)', _dark: 'rgba(115, 115, 115, 1)'}},
        'on-surface': {value: {base: 'rgba(255,255,255, 1)', _dark: 'rgba(255,255,255, 1)'}},
        'brand-default': {value: {base: 'rgba(161, 82, 2, 1)', _dark: 'rgba(251, 133, 16, 1)'}},
        'brand-hover': {value: {base: 'rgba(136, 69, 2, 1)', _dark: 'rgba(252, 160, 69, 1)'}},
        'on-media': {
            primary: {value: 'rgba(255, 255, 255,1)'},
            brand: {value: 'rgba(161, 82, 2, 1)'}
        },
        system: {
            success: {value: {base: 'rgba(80, 114, 68, 1)', _dark: 'rgba(80, 147, 89, 1)'}},
            'success-on-surface': {
                value: {base: 'rgba(56, 103, 62, 1)', _dark: 'rgba(56, 103, 62, 1)'}
            },
            warning: {value: {base: 'rgba(161, 82, 2, 1)', _dark: 'rgba(251, 133, 16, 1)'}},
            error: {value: {base: 'rgba(160, 64, 64, 1)', _dark: 'rgba(220, 100, 95, 1)'}},
            'error-on-surface': {
                value: {base: 'rgba(136, 59, 60, 1)', _dark: 'rgba(160, 64, 64, 1)'}
            },
            placeholder: {value: {base: 'TBD-??', _dark: 'TBD-??'}}, // todo
            disabled: {value: {base: 'TBD-??', _dark: 'TBD-??'}} // todo
        }
    },

    border: {
        subtle: {
            value: {
                base: 'rgba(0, 0, 0, 0.1)',
                _dark: 'rgba(255, 255, 255, 0.1)'
            }
        },
        medium: {
            value: {
                base: 'rgba(0, 0, 0, 0.16)',
                _dark: 'rgba(255, 255, 255, 0.16)'
            }
        },
        strong: {value: {base: 'rgba(15, 15, 15, 1)', _dark: 'rgba(252, 252, 252, 1)'}},
        brand: {value: {base: 'rgba(182, 92, 2, 1)', _dark: 'rgba(237, 119, 3, 1)'}},
        system: {
            success: {value: {base: 'rgba(80, 114, 68, 1)', _dark: 'rgba(80, 147, 89, 1)'}},
            warning: {value: {base: 'rgba(161, 82, 2, 1)', _dark: 'rgba(251, 133, 16, 1)'}},
            error: {value: {base: 'rgba(160, 64, 64, 1)', _dark: 'rgba(220, 100, 95, 1)'}}
        }
    },

    icons: {
        primary: {value: {base: 'rgba(30, 30, 30, 1)', _dark: 'rgba(255,255,255, 1)'}},
        'primary-inverted': {value: {base: 'rgba(255,255,255, 1)', _dark: 'rgba(15, 15, 15, 1)'}},
        secondary: {value: {base: 'rgba(66, 66, 66, 1)', _dark: 'rgba(115, 115, 115, 1)'}},
        brand: {value: {base: 'rgba(182, 92, 2, 1)', _dark: 'rgba(237, 119, 3, 1)'}},
        'on-color': {value: 'rgba(255,255,255, 1)'},
        'on-color-inverted': {value: 'rgba(15, 15, 15, 1)'},
        system: {
            success: {value: {base: 'rgba(80, 114, 68, 1)', _dark: 'rgba(80, 147, 89, 1)'}},
            'success-on-surface': {
                value: {base: 'rgba(64, 118, 71, 1)', _dark: 'rgba(56, 103, 62, 1)'}
            },
            warning: {value: {base: 'rgba(161, 82, 2, 1)', _dark: 'rgba(251, 133, 16, 1)'}},
            error: {value: {base: 'rgba(160, 64, 64, 1)', _dark: 'rgba(220, 100, 95, 1)'}},
            'error-on-surface': {
                value: {base: 'rgba(160, 64, 64, 1)', _dark: 'rgba(160, 64, 64, 1)'}
            },
            placeholder: {value: {base: 'TBD-??', _dark: 'TBD-??'}}, //todo
            disabled: {value: {base: 'TBD-??', _dark: 'TBD-??'}} //todo
        }
    },

    gradient: {
        bottom: {
            'darken-100': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)'
                }
            },
            'darken-80': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.80) 100%)'
                }
            },
            'darken-60': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.60) 100%)'
                }
            },
            'darken-40': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.40) 100%)'
                }
            },
            'darken-20': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.20) 100%)'
                }
            },
            'lighten-100': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)'
                }
            },
            'lighten-80': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.80) 100%)'
                }
            },
            'lighten-60': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.60) 100%)'
                }
            },
            'lighten-40': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.40) 100%)'
                }
            },
            'lighten-20': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.20) 100%)'
                }
            }
        },
        top: {
            'darken-100': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-80': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-60': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-40': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-20': {
                value: {
                    base: 'linear-gradient(180deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'lighten-100': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-80': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-60': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-40': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-20': {
                value: {
                    base: 'linear-gradient(180deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            }
        },
        left: {
            'darken-100': {
                value: {
                    base: 'linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-80': {
                value: {
                    base: 'linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-60': {
                value: {
                    base: 'linear-gradient(90deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-40': {
                value: {
                    base: 'linear-gradient(90deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-20': {
                value: {
                    base: 'linear-gradient(90deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'lighten-100': {
                value: {
                    base: 'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-80': {
                value: {
                    base: 'linear-gradient(90deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-60': {
                value: {
                    base: 'linear-gradient(90deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-40': {
                value: {
                    base: 'linear-gradient(90deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            },
            'lighten-20': {
                value: {
                    base: 'linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0) 100%)'
                }
            }
        },
        // new gradients are added for Highlight Stacks update
        right: {
            'darken-80': {
                value: {
                    base: 'linear-gradient(270deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-40': {
                value: {
                    base: 'linear-gradient(270deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            }
        },
        combo: {
            'darken-80-left-top': {
                value: {
                    base:
                        'linear-gradient(90deg, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0) 100%),' +
                        'linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'darken-40-left-top': {
                value: {
                    base:
                        'linear-gradient(90deg, rgba(0,0,0,0.40) 0%, rgba(0,0,0,0) 100%),' +
                        'linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 100%)'
                }
            },
            'beige-darken-bottom': {
                value: {
                    base: 'linear-gradient(180deg, rgba(246, 243, 239, 1) 0%, rgba(223, 214, 207, 1) 100%)',
                    _dark: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%)'
                }
            }
        }
    }
})

export const colors = defineSemanticTokens.colors({
    ...chakraSemanticColors,
    ...leapSemanticColors
})
